import { deepMerge } from '@websolutespa/bom-core';
import { LlmTheme } from '../types';

export const defaultTheme = {
  font: {
    primary: 'Aeonik',
    secondary: 'Capraia',
  },
  color: {
    neutral: {
      '100': '#ffffff', // *
      '200': '#e8e8e8', // *
      '300': '#bdbdbd',
      '500': '#7c7c7c',
      '600': '#525252',
      '700': '#3d3d3d',
      '800': '#292929',
      '900': '#000000', // *
    },
    base: {
      '100': '#003c8c', // *
      '200': '#73c3ff', // *
      '300': '#96dca0', // *
      '400': '#dcdc3c', // *
      '500': '#007378', // *
      '600': '#b41e5f',
      '700': '#aa96f0',
      '800': '#cda582',
      '900': '#ffe6a0',
    },
    blob: {
      '100': 'var(--llm-color-base-400)',
      '200': '#d0c911',
      '300': 'var(--llm-color-base-100)',
      '400': '#054ead',
      '500': 'var(--llm-color-base-300)',
      '600': '#0ba224',
    },
    background: 'var(--llm-color-base-100)',
    foreground: 'var(--llm-color-neutral-100)',
    primary: {
      background: 'var(--llm-color-base-200)',
      foreground: 'var(--llm-color-neutral-100)', // 'var(--llm-color-base-100)'
    },
    secondary: {
      background: 'var(--llm-color-base-500)',
      foreground: 'var(--llm-color-neutral-100)',
    },
    accent: {
      background: 'transparent',
      foreground: 'var(--llm-color-base-400)',
    },
  },
  border: '1px solid var(--llm-color-neutral-200)',
  canvas: {
    opacity: 0.8,
  },
  trigger: {
    size: '60px',
    background: 'var(--llm-color-base-200)',
    foreground: 'var(--llm-color-base-100)',
    boxShadow: '0 0 30px rgba(0, 0, 0, 0.3)',
  },
  hint: {
    fontFamily: 'var(--llm-font-primary)',
    background: 'linear-gradient(rgba(154, 154, 154, 0.2) 10%, rgba(221, 221, 221, 0.1) 80%)',
    foreground: 'var(--llm-color-foreground)',
    border: '1px solid rgba(237, 237, 237, 0.3)',
    borderRadius: '12px',
  },
  pill: {
    fontFamily: 'var(--llm-font-primary)',
    background: 'rgba(255, 255, 255, 0.2)',
    foreground: 'var(--llm-color-foreground)',
    border: '1px solid rgba(237, 237, 237, 0.3)',
    borderRadius: '5px',
  },
  input: {
    fontFamily: 'var(--llm-font-secondary)',
    background: 'var(--llm-color-neutral-100)',
    foreground: 'var(--llm-color-neutral-900)',
    accent: 'var(--llm-color-base-100)',
  },
  checkbox: {
    border: '2px solid var(--llm-color-neutral-100)',
  },
};

export function getTheme(...overrides: (Partial<LlmTheme> | undefined)[]) {
  let theme = { ...defaultTheme };
  overrides.forEach(override => {
    theme = deepMerge(theme, { ...override });
  });
  return theme;
}
